import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import {
  getViewerPanelPaddingSx,
  viewerPanelBodySx,
  viewerPanelHeaderSx,
  viewerPanelHeadingGroupSx,
  viewerPanelSurfaceSx,
  viewerPanelTitleSx,
} from "./panelStyles";

export default function FocusedElementPanel({
  initialPosition, displayName, description, isPhone, zoomControl, children,
}) {
  const [centered, setCentered] = useState(false);
  useEffect(() => {
    // Paint the selection origin before beginning the focus movement.
    let frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(() => setCentered(true));
    });
    return () => cancelAnimationFrame(frame);
  }, []);

  const motionSx = {
    position: "absolute",
    left: centered || !initialPosition ? "50%" : initialPosition.x,
    transition: "left 650ms cubic-bezier(0.16, 1, 0.3, 1), top 650ms cubic-bezier(0.16, 1, 0.3, 1)",
    "@media (prefers-reduced-motion: reduce)": { transition: "none" },
    zIndex: 1005,
    pointerEvents: "auto",
  };

  return (
    <>
    {zoomControl && <Box sx={{
      ...motionSx,
      top: centered || !initialPosition ? "50%" : initialPosition.y,
      transform: "translate(-50%, -50%)",
    }}>{zoomControl}</Box>}
    <Box
      data-testid="viewer-focused-element-panel"
      onPointerDown={(event) => event.stopPropagation()}
      onPointerUp={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
      onMouseUp={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
      onTouchStart={(event) => event.stopPropagation()}
      onTouchEnd={(event) => event.stopPropagation()}
      onWheel={(event) => event.stopPropagation()}
      sx={{
        ...viewerPanelSurfaceSx,
        ...getViewerPanelPaddingSx(isPhone),
        ...motionSx,
        // Anchor the panel's bottom above the centered model and Zoom control.
        top: centered || !initialPosition ? "calc(50% - 64px)" : initialPosition.y - 64,
        transform: "translate(-50%, -100%)",
        width: isPhone ? "calc(100% - 28px)" : 360,
        maxWidth: "calc(100% - 28px)",
        maxHeight: "calc(50% - 96px - var(--app-header-height, 72px))",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: 1.25,
      }}
    >
      <Box sx={{ minHeight: 0, overflowY: "auto", overscrollBehavior: "contain" }}>
        <Box sx={viewerPanelHeaderSx}>
          <Box sx={viewerPanelHeadingGroupSx}>
            <Typography component="h2" sx={{
              ...viewerPanelTitleSx,
              // Focus titles must remain readable in full on narrow screens.
              whiteSpace: "normal", overflowWrap: "anywhere",
            }}>{displayName}</Typography>
          </Box>
        </Box>
        {description && <Typography component="p" sx={{
          ...viewerPanelBodySx, mb: 0, mt: 1, textAlign: "left", whiteSpace: "pre-wrap", overflowWrap: "anywhere",
        }}>{description}</Typography>}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1.5, flexShrink: 0 }}>
        {children}
      </Box>
    </Box>
    </>
  );
}
